import React from "react"
import styled from "styled-components"

import { Box, Flex } from "components/box"
import { H4, Paragraph } from "components/text"

import { Color } from "theme"

type CategoryHeaderProps = {
  title: string
  description: string
  bgColor: Color
}

const Description = styled(Paragraph).attrs({
  color: "gunmetal"
})`
  font-size: 1rem;
`

const BorderBox = styled(Box)<{ bgColor: Color }>`
  width: 0.6875rem;
  height: inherit;
  border-radius: 6.25rem;
  background: ${props => props.theme.colors[props.bgColor]};
`

const CategoryHeader: React.FC<CategoryHeaderProps> = ({ title, description, bgColor }) => (
  <Flex>
    <BorderBox bgColor={bgColor} />
    <Flex ml={[3, null, 4]} flexDirection="column">
      <H4 mb={[1, null, 0]} color="evergreen">
        {title}
      </H4>
      <Description>{description}</Description>
    </Flex>
  </Flex>
)

export default CategoryHeader
